<template>
    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 1.6C5.39763 1.6 1.66667 5.18172 1.66667 9.6V11.2H3.33333C4.25381 11.2 5 11.9163 5 12.8V17.6C5 18.4837 4.25381 19.2 3.33333 19.2H1.66667C0.746192 19.2 0 18.4837 0 17.6V9.6C0 4.29807 4.47715 0 10 0C15.5228 0 20 4.29807 20 9.6V19.2C20 21.4091 18.1345 23.2 15.8333 23.2H12.277C11.9889 23.6782 11.4502 24 10.8333 24H9.16667C8.24619 24 7.5 23.2837 7.5 22.4C7.5 21.5163 8.24619 20.8 9.16667 20.8H10.8333C11.4502 20.8 11.9889 21.1218 12.277 21.6H15.8333C17.214 21.6 18.3333 20.5255 18.3333 19.2H16.6667C15.7462 19.2 15 18.4837 15 17.6V12.8C15 11.9163 15.7462 11.2 16.6667 11.2H18.3333V9.6C18.3333 5.18172 14.6024 1.6 10 1.6Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
  name: 'SupportIcon'
}
</script>